module.exports = __webpack_public_path__ + "img/showcase.93450f1f.png";